module.exports = __webpack_public_path__ + "media/images/pc/plans/plan_reason_title_deco-53ddf8668dc68cffdae5850a860f368c.svg";